
(function () {
	'use strict';

	angular.module('trakeyeApp').factory('Configs', ['$rootScope', '$http', function ($rootScope, $http) {

		var service = {};
        var config_catName = "ROLLOUT_FEATURES"
        var latitude = "DEFAULT_LATITUDE";
        var longitude = "DEFAULT_LONGITUDE"

		service.get = function (name, callback) {
			$http.get('api/configs/' + name).then(function (response) {
				callback(response.data);
			});
		};

        service.rolloutFeatures = function (callback) {
			$http.get('api/configs/'+config_catName).then(function (response) {
                callback(response.data);
            },
            function (error) {
                callback(error);
            });
		};

        service.getLatLng = function (callback) {

			$http.get('api/configs/'+latitude).then(function (response) {
                var dataLat = response.data
                if(dataLat.length && dataLat[0].configValue){
                    $http.get('api/configs/'+longitude).then(function (responseLng) {
                        var dataLng = responseLng.data
                        if(dataLng.length && dataLng[0].configValue){ 
                            callback(dataLat[0].configValue,dataLng[0].configValue);
                        }else{
                            callback(null)
                        }
                    },
                    function (error) {
                        callback(error);
                    });
                }else{
                    callback(null)
                }
            },
            function (error) {
                callback(error);
            });
		}

		return service;
	}]);
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('ConfigList', ConfigList);

    ConfigList.$inject = ['$resource'];

    function ConfigList($resource) {
        var resourceUrl = 'api/configs/configs';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';
    angular.module('trakeyeApp').factory('ConfigUpdate', ConfigUpdate);

    ConfigUpdate.$inject = ['$resource'];

    function ConfigUpdate($resource) {
        var resourceUrl = 'api/configs/configs';

        return $resource(resourceUrl, {}, {
            'update': {
                method: 'PUT'
            },
        });
    }
})();

(function () {
	'use strict';
	angular.module('trakeyeApp').factory('ConfigSave', ConfigSave);

	ConfigSave.$inject = ['$resource'];

	function ConfigSave($resource) {
		var resourceUrl = 'api/configs/configs';

		return $resource(resourceUrl, {}, {
			'save': {
				method: 'POST'
			}
		});
	}
})();

(function() {
	'use strict';

	angular.module('trakeyeApp').factory('ConfigSearch', ConfigSearch);

	ConfigSearch.$inject = [ '$resource' ];

	function ConfigSearch($resource) {
		var service = $resource('api/configs/configs/searchvalue/:searchText', {
			searchText : '@searchText'
		}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
		});

		return service;
	}
})();
